'use strict';

customerZone

    .controller('CancelSubscriptionController', ['$log', 'utils', 'Session', 'SubscriptionService',
        'errorCode', function($log, utils, Session, SubscriptionService, errorCode){
            var self = this;

            var subscriber = Session.subscriber();

            var POLL_INTERVAL_MSECS = 1500;

            if (!subscriber)
                jim.goHome();

            Object.defineProperty(self, 'cancelled', {
                get: function(){
                    return subscriber && subscriber.active.isCancelled();
                }
            });

            self.describeCancellation = function(){
                return utils.format('you_are_about_to_cancel_your_{subscription_name}_subscription',
                    {'subscription_name': subscriber.product.name});
            };

            self.describeEndTimestamp = function(){
                if (!subscriber || !subscriber.validUntil) return '';
                return utils.format('last_day_of_subscription_is_{date}',
                    {date: subscriber.validUntil.format('DD/MM/YYYY')});
            };

            var getSubscription = function(){
                return SubscriptionService.getSubscription(subscriber.id);
            };

            var untilSubscriptionIsCancelled = function(subscription){
                return subscription.isCancelled();
            };

            /**
             * Confirm cancel.
             * @param password the password of the subscription owner
             * @return a promise that will resolve when the cancel has processed (whether successful or not), except
             *         if the given password was incorrect.
             */
            self.confirmCancel = function(password){
                var cancelPromise = SubscriptionService.cancelSubscription(subscriber, password)
                    .then(function() {
                        return utils.poll(getSubscription, untilSubscriptionIsCancelled, POLL_INTERVAL_MSECS, 300000,
                            'subscription cancelled');
                    })
                    .then(function(){
                        return Session.refresh();
                    })
                    .then(function(){
                        subscriber = Session.subscriber();
                    })
                    .catch(function(error){
                        if (errorCode.is(error, errorCode.INVALID_CREDENTIALS)){
                            busy.passThrough('incorrect_password');
                        }
                        throw error;
                    });

                var busy = utils.showBusy(cancelPromise, 'cancelling_subscription', 'cancelling_subscription_done');
                return busy.wrappedPromise;
            };
        }]);
